import {Component, OnInit, Input} from '@angular/core';
import {ApplicationItemViewModel} from './../application-item.view-model';
import {clone} from "lodash";

@Component({
  selector: 'ndms-application-card',
  templateUrl: './application-card.component.html',
  styleUrls: ['./application-card.component.scss']
})

export class ApplicationCardComponent implements OnInit {
  appItem: ApplicationItemViewModel;

  @Input() set applicationItem(value: ApplicationItemViewModel) {
    this.appItem = clone<ApplicationItemViewModel>(value);
  };

  constructor() {
  }

  ngOnInit() {
  }
}
